const CATEGORIES_DATA = ["All", "Academic", "Hobbies", "Front End", "Back End"];
export default CATEGORIES_DATA;
